(() => {
  const root = document.querySelector('[data-referral-page]');
  if (!root) return;

  const form = root.querySelector('[data-referral-form]');
  const input = form?.querySelector('input[name="ref"]');
  const status = root.querySelector('[data-referral-status]');
  const button = form?.querySelector('button[type="submit"]');
  const params = new URLSearchParams(window.location.search);
  const pattern = /^[A-Z0-9_-]{2,32}$/;

  const normalize = (value) => String(value || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9_-]/g, '')
    .slice(0, 32);

  const showStatus = (message, success = false) => {
    if (!status) return;
    status.textContent = message;
    status.classList.toggle('is-success', success);
  };

  const supplied = normalize(params.get('ref'));
  if (input && supplied && pattern.test(supplied)) {
    input.value = supplied;
    showStatus(`Invito ${supplied} riconosciuto.`, true);
  }

  input?.addEventListener('input', () => {
    const clean = normalize(input.value);
    if (input.value !== clean) input.value = clean;
    showStatus('');
  });

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const referralCode = normalize(input?.value);
    if (!pattern.test(referralCode)) {
      showStatus('Inserisci il codice presente nel messaggio ricevuto.');
      input?.focus();
      return;
    }

    button.disabled = true;
    showStatus('Sto preparando il tuo invito…', true);

    try {
      const validationEndpoint = root.dataset.validationEndpoint;
      const validationUrl = new URL(validationEndpoint);
      validationUrl.searchParams.set('code', referralCode);
      const validation = await fetch(validationUrl, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        mode: 'cors',
        credentials: 'omit'
      });
      if (!validation.ok) throw new Error(`Referral validation ${validation.status}`);
      const validationResult = await validation.json();
      if (validationResult.valid !== true) {
        button.disabled = false;
        showStatus('Questo invito è scaduto o inesistente.');
        input?.focus();
        return;
      }

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Referral code': referralCode,
            'Referral program': 'Academy pilot 2026'
          }
        })
      });
      if (!response.ok) throw new Error(`Cart update ${response.status}`);

      const productPath = root.dataset.productPath;
      const productUrl = `${productPath}?ref=${encodeURIComponent(referralCode)}&academy_ref=referral&utm_source=customer_referral&utm_medium=member_get_member&utm_campaign=referral_pilot_2026`;
      const discountCode = root.dataset.discountCode;
      window.location.assign(`/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(productUrl)}`);
    } catch (error) {
      button.disabled = false;
      showStatus('Il carrello ha perso il passo. Riprova tra qualche secondo.');
    }
  });
})();
